/**
 * Web <-> Native 통신 유틸.
 * 모든 메시지는 { type, payload } 규격을 따른다.
 */

/** 네이티브 쉘(IitpNatvApp) 안에서 실행 중인지 */
export const isNativeApp = () =>
    typeof window !== 'undefined' && !!window.ReactNativeWebView?.postMessage;

/**
 * Web -> Native 송신.
 * PC 브라우저에서는 네이티브가 없으므로 콘솔 로그만 남기고 조용히 무시한다.
 */
export function postToNative(type, payload = null) {
    const msg = JSON.stringify({ type, payload });
    if (isNativeApp()) {
        window.ReactNativeWebView.postMessage(msg);
    } else {
        console.log('[postToNative] 네이티브 미연결 —', type, payload);
    }
}

/**
 * Native -> Web 수신 구독.
 * 네이티브가 injectJavaScript 로 dispatch 한 MessageEvent 를 받는다.
 *
 * @returns {() => void} 구독 해제 함수
 */
export function onNativeMessage(handler) {
    const listener = (event) => {
        // 네이티브가 보낸 메시지는 항상 JSON 문자열이다.
        // 다른 라이브러리(iframe 등)가 객체를 던지는 경우가 있어 문자열만 받는다.
        if (typeof event.data !== 'string') return;
        let data;
        try {
            data = JSON.parse(event.data);
        } catch {
            return; // 우리 규격이 아닌 메시지는 무시
        }
        if (!data || typeof data.type !== 'string') return;
        handler(data);
    };
    window.addEventListener('message', listener);
    return () => window.removeEventListener('message', listener);
}
